module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reviewpoint"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberredpoint'
      },
      "replace": ""
    }
  }, [_vm._v("会员集点")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.type === 'create' ? '创建集点' : '修改集点'))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "review-info__wrapper"
  }, [_c('div', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("目标点数")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.exchange_pt) + "点")])])]), _vm._v(" "), _c('div', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("集点条件")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_vm._v("\n            支付满"), _c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.obtain_amt) + "元")]), _vm._v("可集一点\n            "), (_vm.data.obtain_limit == 0) ? _c('span', {
    staticClass: "highlight ml-0",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("/一次付款可集多点")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("礼品名称")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_vm._v(_vm._s(_vm.data.goods_name))])]), _vm._v(" "), _c('div', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("礼品价格")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_vm._v(_vm._s(_vm.data.goods_amt) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_vm._v(_vm._s(_vm.data.start_time) + " - " + _vm._s(_vm.data.expire_time))])]), _vm._v(" "), (!_vm.role.single) ? _c('div', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc__wrapper"
  }, [_c('div', {
    staticClass: "info-desc"
  }, [_c('div', _vm._l((_vm.shopList), function(shop, index) {
    return _c('span', [_vm._v(_vm._s(shop.shopname) + _vm._s(index < _vm.shopList.length - 1 ? "、" : ""))])
  }))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.backToEdit
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_c('i', {
    staticClass: "icon-create"
  }), _vm._v("确认提交")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("预览集点信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3eedec6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reviewpoint/reviewpoint.vue
// module id = 844
// module chunks = 1